<template>
  <MainLayout>
    <section id="hero" class="max-w-[1080px] lg:m-[auto] backgroundgradient backgroundgradient-top">
      <div class="grid max-md:grid-rows-1 lg:grid-cols-5 gap-10 lg:mt-14">
        <div class="flex flex-col gap-y-8 col-span-3">
          <h1 class="text-4xl lg:text-6xl font-bold text-dark font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.products.page.hero.title.pt1') }}
            <span class="text-gradient-primary whitespace-nowrap">{{ t('pages.products.page.hero.title.pt2') }}</span>
            {{ t('pages.products.page.hero.title.pt3') }}
          </h1>

          <p class="text-lighter lg:max-w-[80%] font-semibold text-lg">
            {{ t('pages.products.page.hero.description') }}
          </p>

          <div class="flex gap-x-3 gap-y-4 items-center flex-row">
            <a v-track-event="'onboarding_start'" href="https://merchant.bistroo.nl/register" class="btn btn-lg btn-primary whitespace-nowrap">{{ t('pages.products.page.hero.button') }}</a>
            <a href="https://webforms.pipedrive.com/f/6k1fJdz7xgA49xFsdiLKDuoJ6y0vj7QgYFKhNOo8Gf4SEA7lu5dJ0YDBJRJ67NCUn1" target="_blank" class="btn btn-lg btn-dark whitespace-nowrap ">{{ t('main.actions.product_demo') }}</a>
          </div>
        </div>

        <div class="col-span-3 lg:col-span-2 justify-self-center">
          <img class="lg:max-w-[110%] lg:-mt-8 lg:-ml-5" src="/images/img-hero-page.webp" alt="Bistroo page builder">
        </div>
      </div>

      <img class="max-w-[90%] object-bottom opacity-60 lg:mt-10 lg:pr-10" src="/images/img-logos-greyscale.webp" alt="Trusted by our partners">
    </section>

    <section id="paragraphs" class="max-w-[1080px] max-md:-mt-10 lg:m-[auto]">
      <div class="flex flex-col gap-10 max-lg:items-center max-md:flex-col-reverse max-lg:p-4 lg:grid lg:grid-cols-5">
        <div class="max-lg:order-2 col-span-3 flex flex-col gap-y-8">
          <h1 class="text-3xl lg:text-5xl font-bold text-dark font-markPro lg:max-w-[20ch]">
            {{ t('pages.products.page.paragraphs.paragraph_1.title') }}
          </h1>

          <p class="text-lighter lg:max-w-[75%] font-semibold">{{ t('pages.products.page.paragraphs.paragraph_1.text') }}</p>

          <RouterLink :to="{name: 'pricing.index'}" class="max-lg:order-1 text-gradient-primary text-lg font-semibold flex gap-x-2 items-center">
            <span>{{ t('pages.products.page.paragraphs.paragraph_1.cta') }}</span>
            <i class="bi bi-arrow-right"></i>
          </RouterLink>

        </div>

        <div class="col-span-2">
          <img src="/images/img-page-maintain-menu.webp" alt="Dashboard">
        </div>
      </div>

      <div class="flex flex-col gap-10 max-lg:items-center max-md:flex-col-reverse max-lg:p-4 lg:grid lg:grid-cols-5">
        <div class="col-span-3 flex flex-col gap-y-8 order-1">
          <h1 class="text-3xl lg:text-5xl font-bold text-dark font-markPro lg:max-w-[20ch] lg:pl-[7rem]">
            {{ t('pages.products.page.paragraphs.paragraph_2.title') }}
          </h1>

          <p class="text-lighter lg:max-w-[90%] lg:pl-[7rem] font-semibold">{{ t('pages.products.page.paragraphs.paragraph_2.text') }}</p>
        </div>

        <div class="lg:col-span-2">
          <img src="/images/img-page-updated-automatically.webp" alt="Dashboard">
        </div>
      </div>
    </section>

    <section id="key-features">
      <div class="grid lg:grid-cols-3 gap-8">
        <div class="md:col-span-2 flex flex-col gap-y-8 rounded-lg bg-white drop-shadow">
          <div class="flex flex-col justify-between h-[100%]">
            <div class="flex flex-col gap-y-4 p-8">
              <h4 class="text-xl font-semibold text-gradient-primary font-markPro">{{ t('pages.products.page.key_features.cards.card_1.title') }}</h4>

              <p class="text-lighter">
                {{ t('pages.products.page.key_features.cards.card_1.text') }}
              </p>
            </div>

            <img class="rounded-lg overflow-hidden place-self-end max-lg:pt-5 pl-5" src="/images/products/img-page-block-1.webp" alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-8 rounded-lg bg-white drop-shadow">
          <div class="flex flex-col justify-between h-[100%]">
            <div class="flex flex-col gap-y-4 p-8">
              <h4 class="text-xl font-semibold font-markPro">{{ t('pages.products.page.key_features.cards.card_2.title') }}</h4>

              <p class="text-lighter">
                {{ t('pages.products.page.key_features.cards.card_2.text') }}
              </p>
            </div>

            <img class="rounded-lg overflow-hidden place-self-end px-7" src="/images/products/img-page-block-2.webp" alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-8 rounded-lg bg-white drop-shadow">
          <div class="flex flex-col justify-between h-[100%]">
            <div class="flex flex-col gap-y-4 p-8">
              <h4 class="text-xl font-semibold font-markPro">{{ t('pages.products.page.key_features.cards.card_3.title') }}</h4>

              <p class="text-lighter">
                {{ t('pages.products.page.key_features.cards.card_3.text') }}
              </p>
            </div>

            <img class="rounded-lg overflow-hidden place-self-end pl-6" src="/images/products/img-page-block-3.webp" alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-8 rounded-lg bg-white drop-shadow">
          <div class="flex flex-col justify-between h-[100%]">
            <div class="flex flex-col gap-y-4 p-8">
              <h4 class="text-xl font-semibold font-markPro">{{ t('pages.products.page.key_features.cards.card_4.title') }}</h4>

              <p class="text-lighter">
                {{ t('pages.products.page.key_features.cards.card_4.text') }}
              </p>
            </div>

            <img class="rounded-lg overflow-hidden place-self-end px-2" src="/images/products/img-page-block-4.webp" alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-8 rounded-lg bg-white drop-shadow">
          <div class="flex flex-col justify-between h-[100%]">
            <div class="flex flex-col gap-y-4 p-8">
              <h4 class="text-xl font-semibold text-gradient-primary font-markPro">{{ t('pages.products.page.key_features.cards.card_5.title') }}</h4>

              <p class="text-lighter">
                {{ t('pages.products.page.key_features.cards.card_5.text') }}
              </p>
            </div>

            <img class="rounded-lg overflow-hidden place-self-end" src="/images/products/img-page-block-5.webp" alt="">
          </div>
        </div>
      </div>
    </section>

    <section id="paragraphs_2" class="max-w-[1080px] max-md:-mt-10 lg:m-[auto]">
      <div class="flex flex-col gap-10 max-lg:items-center max-md:flex-col-reverse max-lg:p-4 lg:grid lg:grid-cols-5">
        <div class="max-lg:order-2 col-span-3 flex flex-col gap-y-8">
          <h1 class="text-3xl lg:text-5xl font-bold text-dark font-markPro lg:max-w-[20ch]">
            {{ t('pages.products.page.paragraphs.paragraph_3.title') }}
          </h1>

          <p class="text-lighter lg:max-w-[75%] font-semibold">{{ t('pages.products.page.paragraphs.paragraph_3.text') }}</p>

          <RouterLink :to="{name: 'pricing.index'}" class="max-lg:order-1 text-gradient-primary text-lg font-semibold flex gap-x-2 items-center">
            <span>{{ t('pages.products.page.paragraphs.paragraph_3.cta') }}</span>
            <i class="bi bi-arrow-right"></i>
          </RouterLink>

        </div>

        <div class="col-span-2">
          <img src="/images/merchantpage/template-8.webp" alt="Dashboard">
        </div>
      </div>

      <div class="flex flex-col gap-10 max-lg:items-center max-md:flex-col-reverse max-lg:p-4 lg:grid lg:grid-cols-5">
        <div class="col-span-3 flex flex-col gap-y-8 order-1">
          <h1 class="text-3xl lg:text-5xl font-bold text-dark font-markPro lg:max-w-[20ch] lg:pl-[7rem]">
            {{ t('pages.products.page.paragraphs.paragraph_4.title') }}
          </h1>

          <p class="text-lighter lg:max-w-[90%] lg:pl-[7rem] font-semibold">{{ t('pages.products.page.paragraphs.paragraph_4.text') }}</p>
        </div>

        <div class="lg:col-span-2">
          <img src="/images/img-orderwithgoogle.webp" alt="Dashboard">
        </div>
      </div>
    </section>

    <section id="cta" class="backgroundgradient backgroundgradient-bottom">
      <div class="w-full rounded-2xl py-16 max-md:px-14 lg:pt-26 lg:pb-20 relative overflow-hidden">

        <div class="absolute inset-0 z-10 bg-[#E3EEF7]"></div>
        <div class="parallax "
             data-parallax
             data-parallax-speed="0.05"
             data-parallax-direction="down">

          <div class="relative w-full h-full">
            <img class="absolute top-0 left-0 -translate-x-1/3 h-[150%] rotate-[45%]"
                 src="/images/bg-visual-left-top.webp"
                 alt="">

            <img class="absolute right-0 translate-x-1/3 -top-1/4 lg:-top-1/2 h-1/2 lg:h-full rotate-[-20deg]"
                 src="/images/bg-visual-right-top.webp"
                 alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-5.5 justify-center items-center text-center relative z-30">
          <h4 class="text-[32px] leading-[42px] lg:text-5xl font-bold text-dark text-center font-markPro block tracking-[-0.08rem]">
            {{ t('main.cta_block.open_your_webshop_today') }}
            <span class="text-gradient-primary whitespace-nowrap">
              {{ t('main.cta_block.its_free') }}
            </span>
          </h4>

          <p class="text-lg lg:text-[24px] text-lighter font-semibold">
            {{ t('main.cta_block.start_generating_more_orders') }}
          </p>

          <a v-track-event="'onboarding_start'" href="https://merchant.bistroo.nl/register" class="btn btn-lg btn-primary flex items-center gap-x-3 mt-4">
            <span>
              {{ t('main.cta_block.get_started_for_free') }}
            </span>
            <i class="bi bi-arrow-right text-lg mt-[3px]"></i>
          </a>
        </div>
      </div>
    </section>

  </MainLayout>
</template>

<script setup lang="ts">

import MainLayout from '@/layouts/MainLayout.vue'
import { useI18n } from 'vue-i18n'

const {t, tm, rt} = useI18n()
</script>

<style scoped>

</style>